export default __webpack_public_path__ + "static/media/Niramit-Medium.094ac99e.ttf";